import Modal from "../shared/Modal";
import "./ModalWebsiteIngestAlert.css";

type ModalWebsiteIngestAlertProps = {
  data: any | null;
  isOpen: boolean;
  onCancel: () => void;
  onClose: () => void;
  onContinue: () => void;
};

const ModalWebsiteIngestAlert = ({
  isOpen,
  onClose,
  onCancel,
  onContinue,
  data,
}: ModalWebsiteIngestAlertProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={true}
        allowClickout={true}>
        {data && (
          <div id="modal-website-ingest">
            <div className="modal-website-ingest-title">
              Website Crawl Complete
            </div>

            <div className="modal-website-ingest-content">
              {data.urlCount && (
                <p>{`We found ${data.urlCount} ${data.urlCount !== 1 ? "pages." : "page."}`}</p>
              )}
              {(data.maxCountMet || data.maxDepthMet) && (
                <p>
                  Please note, we stopped the crawl due to the following
                  reasons:
                </p>
              )}
              {data.maxCountMet && <p>{`Maximum page count was reached`}</p>}
              {data.maxDepthMet && <p>{`Maximum deth was reached`}</p>}
              {data.urlCount && data.urlCount > 0 && (
                <p>
                  Next, we will load page title and information for all found
                  pages.
                </p>
              )}
            </div>

            <div className="modal-website-ingest-footer">
              <div className="modal-website-ingest-buttons">
                <button
                  onClick={() => onCancel()}
                  className="collections-button">
                  Cancel
                </button>
                <button
                  onClick={() => onContinue()}
                  className="collections-button">
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default ModalWebsiteIngestAlert;
